import { UserRoleType } from "../../../types/admin/User";
import { isType } from "../../enumChecker";

const isUserRoletype = (types: UserRoleType[], ...matchTypes: Array<keyof typeof UserRoleType>) => {
  return types.reduce((sum, current) => sum || isType<typeof UserRoleType>(current, ...matchTypes), false);
};

export const userCanAccessRealEstateUnit = (types: UserRoleType[]) => {
  return isUserRoletype(
    types,
    UserRoleType.KVY_HALDUR,
    UserRoleType.JK_KOORDINAATOR,
    UserRoleType.JK_KOOSTAJA,
    UserRoleType.REGISTRI_HALDUR,
  );
};

export const userCanApproveUnit = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.KVY_HALDUR, UserRoleType.JK_KOORDINAATOR, UserRoleType.REGISTRI_HALDUR);
};
export const isEitherHaldur = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.KVY_HALDUR, UserRoleType.REGISTRI_HALDUR);
};
export const userCanRemoveUnit = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.KVY_HALDUR, UserRoleType.REGISTRI_HALDUR);
};
export const userCanRemoveUnitVersion = (types: UserRoleType[]) => {
  return isUserRoletype(
    types,
    UserRoleType.KVY_HALDUR,
    UserRoleType.JK_KOORDINAATOR,
    UserRoleType.REGISTRI_HALDUR,
    UserRoleType.JK_KOOSTAJA,
  );
};
export const userCanAddParentage = (types: UserRoleType[]) => {
  return isUserRoletype(
    types,
    UserRoleType.KVY_HALDUR,
    UserRoleType.REGISTRI_HALDUR,
    UserRoleType.JK_KOORDINAATOR,
    UserRoleType.JK_KOOSTAJA,
  );
};
export const userCanEndUnit = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.KVY_HALDUR, UserRoleType.REGISTRI_HALDUR, UserRoleType.JK_KOORDINAATOR);
};
// UserRoleType.JK_KOOSTAJA
export const userCanEndUnitPKVU = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.JK_KOOSTAJA);
};
export const canRoleOpenBulkEdit = (types: UserRoleType[]) => {
  return isUserRoletype(
    types,
    UserRoleType.KVY_HALDUR,
    UserRoleType.REGISTRI_HALDUR,
    UserRoleType.JK_KOORDINAATOR,
    UserRoleType.JK_KOOSTAJA,
  );
};
export const canRoleBulkEdit = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.KVY_HALDUR, UserRoleType.REGISTRI_HALDUR);
};
export const canRoleEditAllDecisionFields = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.KVY_HALDUR, UserRoleType.REGISTRI_HALDUR, UserRoleType.JK_KOORDINAATOR);
};

export const canRoleDoCoordinatorActions = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.KVY_HALDUR, UserRoleType.REGISTRI_HALDUR, UserRoleType.JK_KOORDINAATOR);
};
export const canRoleDoKoostajaActions = (types: UserRoleType[]) => {
  return isUserRoletype(types, UserRoleType.JK_KOOSTAJA);
};
